import { useSignatureSourceOptions } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/signatureSelection/useSignatureSourceOptions';
import { useSignatureInsertionRequest } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/signatureSelection/useSignatureInsertionRequest';
import { useSignatureSelectionState } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/signatureSelection/useSignatureSelectionState';
import { useMemo } from 'react';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { useUnlayerUIContext } from '@/context/UnlayerUIContext';

/**
 * Coordinates compose signature loading, selection rules, and insertion requests.
 * The public surface stays small while the internal responsibilities are split
 * into focused hooks for source loading, selection state, and request creation.
 */
export const useEmailSignatureSelection = () => {
	const { programmaticDesignLoadRevision } = useUnlayerUIContext();
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const { values } = useFormikContext();
	const selectedFrom = values.from;

	const sourceOptions = useSignatureSourceOptions();
	const insertionRequest = useSignatureInsertionRequest({ userDetails });
	const selectionState = useSignatureSelectionState({
		activeSignatureOptions: sourceOptions.activeSignatureOptions,
		programmaticDesignLoadRevision,
		queueSignatureInsertion: insertionRequest.queueSignatureInsertion,
		selectedFrom,
		signatureOptions: sourceOptions.signatureOptions,
	});

	return {
		activeSource: sourceOptions.activeSource,
		handleSignatureSelect: selectionState.handleSignatureSelect,
		isFetchingSignature:
			insertionRequest.isFetchingLegacySignature || sourceOptions.isFetchingUnlayerSignatures,
		isSignatureDisabled: sourceOptions.isSignatureDisabled,
		signatureDisabledReason: sourceOptions.signatureDisabledReason,
		signatureError: insertionRequest.signatureError,
		signatureInsertRequest: insertionRequest.signatureInsertRequest,
		signatureOptions: sourceOptions.signatureOptions,
		selectedSignature: selectionState.selectedSignature,
	};
};
